import { render, staticRenderFns } from "./InternalArticlesTransferred.vue?vue&type=template&id=78019d0a&scoped=true"
import script from "./InternalArticlesTransferred.vue?vue&type=script&lang=js"
export * from "./InternalArticlesTransferred.vue?vue&type=script&lang=js"
import style0 from "./InternalArticlesTransferred.vue?vue&type=style&index=0&id=78019d0a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78019d0a",
  null
  
)

export default component.exports